import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export async function swalPromptYN(options: any): Promise<boolean> {
  const confirm = await swal.fire(options);
  //  yes
  return confirm.value;
}
